import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7545cba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "proposal-create relative" }
const _hoisted_2 = {
  key: 0,
  class: "proposal-create__starting text-medium flex items-center justify-between"
}
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "proposal-create__starting__description" }
const _hoisted_5 = { class: "proposal-create__starting__value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "This operation will change ALL of the margins in the proposal. Are You sure?"),
  /*#__PURE__*/_createElementVNode("small", null, "If You want to change margins only for the \"Outbound\", \"Returns\" or \"Surcharges\" tab please use button \"GM\" from the tab toolbar")
], -1))
const _hoisted_7 = { class: "proposal-create__content relative" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "flex mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_proposal_header = _resolveComponent("proposal-header")!
  const _component_layout_header = _resolveComponent("layout-header")!
  const _component_PercentInput = _resolveComponent("PercentInput")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_modal = _resolveComponent("modal")!
  const _component_tabs_navigation = _resolveComponent("tabs-navigation")!
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layout_header, null, {
      default: _withCtx(() => [
        (_ctx.customer)
          ? (_openBlock(), _createBlock(_component_proposal_header, {
              key: 0,
              ref: "proposalHeader",
              customer: _ctx.customer,
              proposal: _ctx.proposal,
              "show-gross-margin-button": true,
              "show-save-button": true,
              "is-saving": _ctx.isSaving,
              onSaveClick: _ctx.saveProposal
            }, null, 8, ["customer", "proposal", "is-saving", "onSaveClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showStartingPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('proposal.starting.setup')), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('proposal.starting.setup_desc')), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('proposal.starting.gross_value')), 1),
              _createVNode(_component_PercentInput, {
                class: "ml-3",
                modelValue: _ctx.startingGrossMargin,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startingGrossMargin) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.showChangeGrossMarginConfirm = true), ["enter"]))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode(_component_outline_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showChangeGrossMarginConfirm = true)),
            disabled: _ctx.isStartingGrossMarginInvalid
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('general.save')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      type: "warning",
      modelValue: _ctx.showChangeGrossMarginConfirm,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showChangeGrossMarginConfirm) = $event)),
      onConfirmClick: _ctx.setupGrossMargin
    }, {
      title: _withCtx(() => [
        _createTextVNode("Warning")
      ]),
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirmClick"]),
    _createVNode(_component_tabs_navigation, { tabs: [
            {name: 'proposal.tabs.outbound', routeName: 'proposal.form.outbound'},
            {name: 'proposal.tabs.returns', routeName: 'proposal.form.returns'},
            {name: 'proposal.tabs.surcharges', routeName: 'proposal.form.surcharges'},
            {name: 'proposal.tabs.content', routeName: 'proposal.form.content'}
        ] }, null, 8, ["tabs"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.isSaving || _ctx.isProposalsProcessing)
          ? (_openBlock(), _createBlock(_component_content_loader, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            (_openBlock(), _createBlock(_KeepAlive, null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ], 1024))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_outline_button, {
          onClick: _ctx.saveProposal,
          "is-loading": _ctx.isSaving
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('general.button.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "is-loading"])
      ])
    ])
  ]))
}